import React from "react";
import styled from "styled-components";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Dialog = styled.div`
  border-radius: 2px;
  background: #232323;
  padding: 1em 3em;
  @media screen and (max-width: 500px) {
    & {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 1em;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
  }
`;

const YesButton = styled.button`
  background-color: #795548;
  border: none;
  padding: 1em 3em;
  border-radius: 2px;
  font-size: 1em;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  color: #fff;
  white-space: nowrap;
  float: right;
  margin-top: 3em;
`;

const NoButton = YesButton.extend`
  float: left;
  background-color: #555;
`;

const ConfirmationDialog = ({ onConfirm, watch }) => (
  <Backdrop>
    <Dialog>
      <h1>Ta bort bevakning</h1>
      <p>Vill du ta bort bevakning av {watch.name}?</p>

      <div>
        <YesButton onClick={() => onConfirm(true)}>Ja</YesButton>
        <NoButton onClick={() => onConfirm(false)}>Nej</NoButton>
      </div>
    </Dialog>
  </Backdrop>
);

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/ConfirmationDialog.js